import React, { FC } from "react";
import { getImageUrl } from "src/utils/getImageUrl";

interface Props {
  title: string;
  image?: string;
}

export const MessageInfo: FC<Props> = ({ title, image }) => (
  <div className="flex gap-5 h-14 bg-white-base/50 rounded-20">
    {image && (
      <div className="w-32 sm:w-50 lg:w-80">
        <img
          className="w-full h-full object-cover object-center rounded-20"
          src={getImageUrl(image)}
          alt={title}
        />
      </div>
    )}

    <h4 title={title} className="flex-1 px-3 sm:px-5 self-center line-clamp-1">
      {title}
    </h4>

    {/* this part will be next release */}
    {/* <div className="grid grid-cols-2 gap-5 flex-1 text-purple-base border-black-base/20 text-center text-base font-medium">
      <div className="flex items-center justify-center px-5 py-3 border border-black-base/20 bg-white-base/50 rounded-20">
        Media
      </div>
      <div className="flex items-center justify-center px-5 py-3 border border-black-base/20 bg-white-base/50 rounded-20">
        Files
      </div>
    </div> */}
  </div>
);
